// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 9308 ? "vendor-styles" : chunkId) + "." + {"168":"1b2f974be50a2b0113b6","1815":"dad186a5db407f240291","2956":"eb03c6c4db43bfb94cb2","9308":"5a8f81f1819675bc4ae5"}[chunkId] + ".css";
};